export default __webpack_public_path__ + "static/media/hero.77066233.svg";